export default {
  common: {
    chiller: "Chiller",
    chilledWaterPump: "Chilled water pump",
    coolingTower: "Cooling tower",
    nextStep: "Next step",
    previousStep: "Previous step",
    objective: "Objective",
    preRetrofit: "Pre retrofit",
    postRetrofit: "Post retrofit",
    retrofitSetup: "Retrofit setup",
    equipmentRated: "Equipment rated",
    equipmentConfig: "Equipment & configuration",
    retrofitSummary: "Retrofit summary",
    cwp: "CWP",
    condenderWaterPump: "Condender water pump",
    chwp: "CHWP",
    ct: "CT",
    other: "Other",
    otherEquipment: "Other equipment",
    chillerOneNos: "Chiller (1 nos.)",
    condenderWaterPumpOneNos: "Condender water pump (1 nos.)",
    chilledWaterPumpOneNos: "Chilled water pump (1 nos.)",
    coolingTowerFanOneNos: "Cooling tower (1 nos.)",
    controlOptimization: "Control Optimization",
    commonHeader: "Common Header",
    dedicatedOneOnOne: "Dedicated (1-1)",
    pleaseInput: "Please input",
    pleaseEnterHere: "Please enter here",
    cancel: "Cancel",
    confirm: "Confirm",
    years: "Years",
    noProjectInfo: "No project info",
    pleaseInputData: "Please input data",
    systemOptionRequired: "System option is required",
    proposedEquipmentRequired: "proposedEquipment is required",
    profileEquipmentSetting: "Profile Equipment Setting",
    Total: "Total"
  },
  objective: {
    projectObjective: "Project objective",
    chillerEfficiency: "Chiller efficiency",
    chillerPlantEfficiency: "Chiller plant efficiency",
    heatingEfficiency: "Heating efficiency",
    heatingPlantEfficiency: "Heating plant efficiency",
    chillerHeatingEfficiency: "Chiller & heating efficiency",
    pleaseSelectAProjectObjective: "Please select a project objective",
    oneOnOne: "( 1 - 1 )",
    oneOnOneOrPlant: " ( 1 - 1 ) or Plant",
    projectName: "Current project",
    doYouWantSave: "Do you want to save your data to the cloud before close ?",
    start: "Start",
    quickNavigation: "Quick navigation",
    mainMenu: "Main menu",

    establishBaseline: "Establish baseline (Pre retrofit)",
    profile: "Profile",
    siteObservation: "Site observation",
    equipmentSpecification: "Equipment specification",
    baselineInput: "Baseline input",
    summary: "Summary",
    generateReport: "Generate report",

    finalizeYourProposal: "Solutions option (Post retrofit)",
    finalizeAnalysis: "Finalize analysis",
    retrofitSetup: "Retrofit setup",
    equipmentConfig: "Equipment & configuration",
    financialAnalysis: "Financial analysis",
    proposedConfig: "Proposed configuration",
    systemOption: "System option",
    ProfileEquipment: "Profile & equipment",
    baselinePreview: "Baseline preview",
    profileEquipment: "Profile & equipment",
    selectProposedEquipments: "Select proposed equipments",
    pleaseSelectEquipments: "Please select equipments.",

    clusterSetting: "Cluster setting",
    generateOption: "Generate option",

    baselineConfig: "Baseline configuration",
    monthlyBaseline: "Monthly baseline"
  },
  setup: {
    systemOption: "System option",
    chillerOnly: "Chiller only",
    chillerWithAssociatedEquipment: "Chiller with associated equipment",
    controlOnly: "Control only",
    proposedLayout: "Proposed layout",
    series: "Series",
    parallel: "Parallel",
    proposedEquipment: "Proposed equipment"
  },
  rated: {
    newEquipment: "Add equipment",
    ratedInputPower: "Rated input power",
    ratedCoolingCapacity: "Rated cooling capacity",
    chillerLabel: "Chiller label",
    type: "Type",
    chillerBrandModel: "Chiller brand & model",
    yearInstalled: "Year installed",
    ratedDesignFlowRate: "Rated design flow rate",
    pressureHead: "Pressure head",
    vfd: "Is a Variable Frequency Drive installed",
    yes: "Yes",
    no: "No",
    noofFansCT: "No. of fans/CT",
    equipmentLabel: "Equipment label",
    category: "Category",
    brand: "Brand",
    otherEquipment: "Other equipment",
    inputEcatPerformanceData: "Input Ecat performance data",
    load: "Load",
    coolingLoad: "Cooling load",
    inputPower: "Input power",
    chillerWaterPumpLabel: "Chilled water pump label",
    ratedMotorFrequency: "Rated motor frequency",
    minimumMotorFrequency: "Mininum motor frequency",
    motor: "Motor",
    applicableChiller: "Applicable chiller",
    condenserWaterPumpLabel: "Condender water pump label",
    coolingTowerLabel: "Cooling tower label",
    ratedFanFrequency: "Rated fan frequency",
    minimumFanFrequency: "Mininum fan frequency",
    totalRatedFanPowerPerCT: "Total rated fan power/CT",
    heatRejectionCapacityPerCT: "Heat rejection capacity/CT",
    chillerLabelRequired: "Chiller label is required",
    yellowBlockRequired: "The yellow block is required",
    labelRequired: "Label is required",
    maximumQuantity: "Maximum quantity",

    chilledWaterSupplyTemp: "Chilled water supply temperature",
    outdoorAirTemp: "Outdoor air temperature",

    condenserWaterSupplyTemp: "Condenser water supply temperature",
    singleChillerSellingPrice: "Single chiller selling price",
    singleCHWPSellingPrice: "Single CHWP selling price",
    singleCWPSellingPrice: "Single CWP selling price",
    singleCTSellingPrice: "Single CT selling price",

    singlePrice: "Single selling price"
  },
  summary: {
    chooleYourPreference: "Choose your prefernce",
    higherEfficiencyImprovement: "Higher efficiency improvement",
    lowerInvestment: "Lower Investment",
    higherCostSaving: "Higher cost saving",
    shorterPaybackPeriod: "Shorter payback period",
    option: "Option",
    efficiencyImprovement: "Efficiency improvement",
    returnOnInvestment: "Return on investment",
    costSavingsPerYear: "Cost savings per year",
    paybackPeriod: "Payback period",
    optionDetails: "Option details",
    postRetrofitEfficiency: "Post retrofit efficiency",
    totalEnergySavingsPerYear: "Total energy savings per year",
    investmentAnalysis: "Investment analysis (actual)",
    capex: "CAPEX",
    sellingPrice: "Selling price",
    OverallProjectPrice: "Overall project price",
    chillerCooling: "Chiller-cooling",
    chillerHeatPump: "Chiller-heat pump",
    calculate: "Calculate",
    proposedConfig: "Proposed config",
    projectIntroduction: "Project introduction",
    assumptions: "Assumptions",
    chillerPlant: "Chiller plant",
    chillerPlantConfig: "Chiller plant config",
    peakBuildingCoolingLoad: "Peak building cooling load",
    designChilledWaterSupplyTemp: "Design chilled water supply Temp.",
    designCondenserWaterSupplyTemp: "Design condenser water supply Temp.",
    energyConservationMeasures: "Energy conservation measures",
    pumpingConfig: "Pumping config",
    designFlowRate: "Design flow rate",
    designPressureHead: "Design pressure head",
    vfdFitted: "VFD fitted",
    chillerConfig: "Chiller config",
    condenserWaterPump: "Condenser water pump",
    coolingTowerConfig: "Cooling tower config",
    heatRejectionCapacity: "Heat rejection capacity",
    designCoolingTowerApproach: "Design cooling tower approach",
    generateReport: "Generate report",
    confirmCalculation: "Confirm calculation",
    doYouNeedCalculationAgain: "The calculation result already exists. Do you need to recalculate.",
    recalculate: "Recalculate",
    coolingTower: "Cooling tower",
    chiller: "Chiller",
    chilledWaterPump: "Chilled water pump",

    fillValidNumericalValue: "Please fill in a valid numerical value",
    runningNumber: "Running number"
  },
  profileMap: {
    associatedCWP: "Associated CWP",
    associatedCHWP: "Associated CHWP",
    associatedCT: "Associated CT",
    profileId: "Profile ID",
    donotNeedmanipulate: "In automatic mode, you do not need to manipulate profiles.",

    automatic: "Automatic",
    manual: "Manual",
    pathAndMethod: "Path & method",
    months: "Months",
    running: "Running",
    daysPerMonth: "days / month",
    chiller: "Chiller"
  }
  // reportFocusDlg: {
  //   selectCustomerReportingFocus: "Select Customer Reporting Focus",
  //   roiLedSummary: "ROI-Led Summary",
  //   roiLedSummaryDetails: "Use when investment, savings, and payback are available.",
  //   efficiencyImprovementLedSummary: "Efficiency Improvement-Led Summary",
  //   efficiencyImprovementLedSummaryDetails: "Use when the decision is based mainly on efficiency improvement and ROI is unavailable or not meaningful."
  // }
}



// WEBPACK FOOTER //
// ./src/locale/post/en.js